import { render, staticRenderFns } from "./Q&A.vue?vue&type=template&id=b394c09e&scoped=true&"
import script from "./Q&A.vue?vue&type=script&lang=js&"
export * from "./Q&A.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b394c09e",
  null
  
)

export default component.exports